import React from 'react'
import styled from '@emotion/styled'
import FAQ from '../landing/FAQ.js'
import DoneModal from './modals/DoneModal'
import { ModalContentNormal } from './Basics.js'

export default ({ setShowModal }) => (
  <DoneModal name={'FAQ'} title={'Frequently Asked Questions'} onClick={e => setShowModal(false)} informational={true}>
    <LeftAlignContent>
      <FAQ />
    </LeftAlignContent>
  </DoneModal>
)

const LeftAlignContent = styled(ModalContentNormal)`
  text-align: left;
`
